import { useTranslation } from "react-i18next";
import { useLanguageSwitch } from "../../../hooks/useLanguageSwitch";
import {
  LangWrapper,
  CurrentLangButton,
  LangDropdown,
  LangOption,
} from "./LanguageToggle.styles";

// Мінімалістична іконка глобуса
const GlobeIcon = () => (
  <svg
    width="1.25rem"
    height="1.25rem"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="2" y1="12" x2="22" y2="12"></line>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
  </svg>
);

export const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const { switchLanguage } = useLanguageSwitch();

  const languages = [
    { code: "en", label: "English" },
    { code: "uk", label: "Українська" },
    { code: "ru", label: "Русский" },
  ];

  return (
    <LangWrapper>
      <CurrentLangButton>
        <GlobeIcon />
        {/* Показуємо поточну мову великими літерами (EN, UK, RU) */}
        {i18n.language}
      </CurrentLangButton>

      <LangDropdown>
        <div>
          {languages.map((lang) => (
            <LangOption
              key={lang.code}
              isActive={i18n.language === lang.code}
              onClick={() => switchLanguage(lang.code)}
            >
              {lang.label}
            </LangOption>
          ))}
        </div>
      </LangDropdown>
    </LangWrapper>
  );
};
